import React from 'react'

document.body.style.backgroundColor = "#000116";
const ContactPage = () => {
  const [formStatus, setFormStatus] = React.useState('Send')
 const onSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('Submitting...');

    const { name, email, message, organisation } = e.target.elements;

    let formData = {
      name: name.value,
      email: email.value,
      organisation: organisation.value,
      message: message.value,
    };

    try {
      const response = await fetch('https://44p23n309e.execute-api.eu-west-1.amazonaws.com/PROD/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFormStatus('Submitted!');
      } else {
        setFormStatus('Error submitting form');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setFormStatus('Error submitting form');
    }
  };
  return (

    <div className="container mt-5">
      <div className="d-flex justify-content-center mb-4"> </div> {/* Add spacing*/}
      <div className="d-flex justify-content-center mb-4"> </div> {/* Add spacing*/}
      <div className="d-flex justify-content-center mb-4"> </div> {/* Add spacing*/}
      <div className="d-flex justify-content-center mb-4"> </div> {/* Add spacing*/}
      <div className="d-flex justify-content-center mb-4"> </div> {/* Add spacing*/}
      <div className="d-flex justify-content-center"> {/* Center the h1 element */}
      <h1 className="text-info">Interested In Conecting With NCFI?</h1>
      </div>
      <form onSubmit={onSubmit}>
        <div className="text-info">
          <label className="form-label" htmlFor="name">
            Name:
          </label>
          <input className="form-control" type="text" id="name" required />
        </div>
        <div className="text-info">
          <label className="form-label" htmlFor="email">
            Email:
          </label>
          <input className="form-control" type="email" id="email" required />
        </div>
        <div className="text-info">
          <label className="form-label" htmlFor="organisation">
          Organisation:
          </label>
          <input className="form-control" type="organisation" id="organisation" required />
        </div>
        <div className="text-info">
          <label className="form-label" htmlFor="message">
            Message:
          </label>
          <textarea className="form-control mb-3" id="message" required />
        </div>
        <button className="btn btn-danger" type="submit">
          {formStatus}
        </button>

      </form>
      <div style={{ height: '20px' }} /> {/* Add some space after the button */}
      <div style={{ height: '20px' }} /> {/* Add some space after the button */}

    </div>


  )
}


export default ContactPage

